'use strict';
const mmWidgets = require('./mm-widgets');
require('./section-handler-widget');
mmWidgets.fn.showError = function (reason) {
	return this.each(function () {
		const widget = this;
		if (widget.find('[data-mm-section~="error-' + reason + '"]').length) {
			widget.showSection('error-' + reason);
		} else {
			widget.showSection('error');
		}
	});
};
